import { memo } from "react";
import { cn } from "@/lib/utils";
import { formatRating } from "@/utils/format/rating";
import { formatReviewCount } from "@/utils/format/reviewCount";
import { Typography } from "../../Typography";

export type RatingReviewBadgeProps = {
  rating?: number | null;
  reviewCount?: number | null;
  className?: string;
};

const RatingReviewBadge = ({
  rating,
  reviewCount,
  className,
}: RatingReviewBadgeProps) => {
  // if (!rating) {
  //   return null;
  // }

  const formattedRating = formatRating(rating || 0);

  return (
    <div
      className={cn(
        "flex h-[25px] w-[110px] items-center overflow-hidden rounded-md shadow-md bg-white/70",
        className,
      )}
    >
      <Typography
        variant="body-xs"
        className="text-secondary rounded-md bg-white/90 flex h-full w-[51px] items-center justify-center font-semibold"
      >
        {formattedRating}/5
      </Typography>

      <Typography
        variant="body-xs"
        className="flex-1 truncate px-0 text-center"
      >
        {reviewCount ? formatReviewCount({ value: reviewCount }) : "0"}{" "}
        {(reviewCount || 0) > 1 ? " reviews" : " review"}
      </Typography>
    </div>
  );
};

export default memo(RatingReviewBadge);
